module.exports = __webpack_public_path__ + "8ae10d274b25a6eb1d61cb8b8c77c0ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_2.jpg
// module id = 1700
// module chunks = 5